<template>
    <div class="container contact_address" :v-if="this.Address.Title">
        <div>
            <div class="col-12 text-center col-lg-10 offset-lg-1 mt-5 pt-5 pt-lg-0 mt-lg-2 mb-4">
                <span class="heading">{{this.Address.Title}}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center text-md-start col-lg-10 offset-lg-1">
                <div v-if="this.Address.AddressLine1">{{this.Address.AddressLine1}}</div>
                <div v-if="this.Address.AddressLine2">{{this.Address.AddressLine2}}</div>
                <div v-if="this.Address.City || this.Address.State || this.Address.ZipCode">{{this.Address.City}}, {{this.Address.State}} {{this.Address.ZipCode}}</div>
                <div v-if="this.Address.Country">{{this.Address.Country}}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center text-md-start col-lg-10 offset-lg-1">
                <div v-if="this.Contacts.SalesContact === this.Contacts.ServicesContact">
                    <span>{{phoneNo}}:</span> {{this.Contacts.SalesContact}}
                </div>
                <div v-else>
                    <div><span>{{salesNo}}:</span> {{this.Contacts.SalesContact}}</div>
                    <span>{{serviceNo}}:</span> {{this.Contacts.ServicesContact}}
                </div>
            </div>
        </div>
        <div id="bh" v-if="this.WorkHours.length">
            <div class="col-12 text-center col-lg-10 offset-lg-1 mt-5 pt-5 pt-lg-4 mt-lg-2 mb-4">
                <span class="heading">{{this.BusinessHoursLable}}</span>
            </div>
        </div>
        <div class="row" v-if="this.WorkHours.length">
            <div class="col-12 text-center text-md-start col-lg-10 offset-lg-1">
                <ul class="list-unstyled">
                    <li class="days" v-for="(day, index) in this.WorkHours" :key="index">
                        <div class="row" aria-label="working hours">
                            <div class="col pr-10" aria-label="day">{{day.weekDay}}</div>
                            <div class="col" aria-label="opening time">{{day.openingTime}}</div>
                            <div class="col" aria-label="closing time">{{day.closingTime}}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row" v-if="this.ReviewURL">
            <div class="col-12 text-center text-md-start col-lg-10 offset-lg-1">
                <a :href="this.ReviewURL" class="review" target="_blank">{{this.ReviewLabel}}</a>
            </div>
        </div>
    </div>
</template>
<script>
    import "bootstrap/dist/css/bootstrap.min.css";
    import { businessHours,reviewDealership, phoneNo, salesNo, serviceNo } from '../../constants/labels.config';
    export default {
        name: "ContactAddress",
        data() {
            return {
                Address: {
                    Title: "",
                    AddressLine1: "",
                    AddressLine2: "",
                    Country: "",
                    State: "",
                    City: "",
                    ZipCode: "",
                },
                Contacts: {
                    SalesContact: "",
                    ServicesContact: "",
                },
                WorkHours: [
                    {
                        weekDay: "",
                        openingTime: "",
                        closingTime: ""
                    }
                ],
                ReviewURL: "",
                BusinessHoursLable:"",
                ReviewLabel:"",
                phoneNo, 
                salesNo, 
                serviceNo
            }
        },
        methods: {
            getWrokHours(data) {
                let wh = [];
                data.forEach(element => {
                    wh.push(
                        {
                            weekDay: element.weekDay,
                            openingTime: element.openingTime,
                            closingTime: element.closingTime
                        }
                    );
                });
                return wh;
            }
        },
        mounted() {
            this.Address.Title = window.DEALER_LOCATION.name;
            this.Address.AddressLine1 = window.DEALER_LOCATION.address.addressLine1;
            this.Address.AddressLine2 = window.DEALER_LOCATION.address.addressLine2;
            this.Address.Country = window.DEALER_LOCATION.address.country;
            this.Address.State = window.DEALER_LOCATION.address.state;
            this.Address.City = window.DEALER_LOCATION.address.city;
            this.Address.ZipCode = window.DEALER_LOCATION.address.postalCode;
            this.Contacts.SalesContact = window.DEALER_LOCATION.salesPhoneNo;
            this.Contacts.ServicesContact = window.DEALER_LOCATION.servicePhoneNo;
            this.WorkHours = this.getWrokHours(window.DEALER_LOCATION.operationHours);
            this.ReviewURL = window.DEALER_LOCATION.reviewsURL;
            this.BusinessHoursLable= businessHours;
            this.ReviewLabel=reviewDealership;
        }
    };
</script>